<div class="left" [class.has-back]="back">
  @if (back) {
    <la-icon-button icon="arrow_back" noFocus (action)="back()"></la-icon-button>
  }

  <div class="title-container">
    <ng-content select="[header-title]"></ng-content>
  </div>
  <h1 mat-dialog-title><ng-content></ng-content></h1>
</div>

@if (close && !back) {
  <la-icon-button icon="close" noFocus matDialogClose></la-icon-button>
}
